import { Box, Container } from "@mui/material";
import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material";
import { layout } from "../styles/tokens";

interface PageContentProps {
  children: ReactNode;
  bg?: string;
  sx?: SxProps<Theme>;
}

function PageContent({
  children,
  bg = "background.default",
  sx = {},
}: PageContentProps) {
  return (
    <Box
      sx={{
        py: layout.pagePaddingY,
        bgcolor: bg,
        ...sx,
      }}
    >
      <Container maxWidth="lg">{children}</Container>
    </Box>
  );
}

export default PageContent;
